import { useState } from 'react';
import { PositionTypes } from '../components/Popover/styles/models';

export const useTooltipPosition = () => {
  const [tooltipPosition, updateTooltipPosition] = useState('bottom-right' as PositionTypes);
  const [extraSpaceNeededForToolTip, updateExtraSpaceNeededForToolTip] = useState('0px');

  const positionTooltip = (event) => {
    const clickedEl = event.currentTarget;
    const clickedElRect = clickedEl.getBoundingClientRect();

    const toolTipNode = document.getElementById('tool-tip');

    if (toolTipNode != null) {
      const viewPortWidth = document.documentElement.clientWidth;
      const viewPortHeight = document.documentElement.clientHeight;

      const rx = clickedElRect.x + clickedElRect.width; // most right x
      const lx = clickedElRect.x; // most left x
      const ty = clickedElRect.y; // most top y
      const by = clickedElRect.y + clickedElRect.height; // most bottom y

      const toolTipRect = toolTipNode.getBoundingClientRect();
      const { width: toolTipWidth, height: toolTipHeight } = toolTipRect;
      const topSpaceAvailable = ty >= toolTipHeight + 4; //tool-tip
      const bottomSpaceAvailable = viewPortHeight - by >= toolTipHeight + 4;
      let position: PositionTypes = 'bottom-right';

      const rightSpace = viewPortWidth - lx;
      const leftSpace = rx;
      let val = 0;
      let extraSpaceNeeded = 0;

      if (topSpaceAvailable) {
        if (rightSpace > leftSpace) {
          val = Math.ceil(toolTipWidth - rightSpace);
          position = 'top-right';
        } else {
          val = Math.ceil(toolTipWidth - leftSpace);
          position = 'top-left';
        }
      } else if (bottomSpaceAvailable) {
        if (rightSpace > leftSpace) {
          val = Math.ceil(toolTipWidth - rightSpace);
          position = 'bottom-right';
        } else {
          val = Math.ceil(toolTipWidth - leftSpace);
          position = 'bottom-left';
        }
      }
      extraSpaceNeeded = val > 0 ? val : 0;
      updateExtraSpaceNeededForToolTip(`${extraSpaceNeeded}px`);
      updateTooltipPosition(position);
    }
  };

  return {
    tooltipPosition,
    extraSpaceNeededForToolTip,
    positionTooltip,
  };
};
